import { Link } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

export function EmailVerificationBanner() {
  const user = useAuthStore((s) => s.user);

  if (!user || user.authProvider !== 'email' || user.emailVerifiedAt) {
    return null;
  }

  return (
    <div className="shrink-0 bg-amber-500/15 border-b border-amber-500/30 px-3 py-2 flex flex-wrap items-center justify-center gap-2 text-sm">
      <span className="text-amber-200">
        Verify your email to keep your account recoverable and secure.
      </span>
      <Link
        to="/verify-email"
        className="text-amber-300 hover:text-amber-200 font-medium underline underline-offset-2"
      >
        Verify email
      </Link>
    </div>
  );
}
